import { render, staticRenderFns } from "./AccreditationMissingDocBox.vue?vue&type=template&id=4b7a0e82&scoped=true"
import script from "./AccreditationMissingDocBox.vue?vue&type=script&lang=js"
export * from "./AccreditationMissingDocBox.vue?vue&type=script&lang=js"
import style0 from "./AccreditationMissingDocBox.vue?vue&type=style&index=0&id=4b7a0e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7a0e82",
  null
  
)

export default component.exports